import React, { useEffect, useRef } from "react";
import { nprogress, NavigationProgress } from "@mantine/nprogress";
import { useLocation } from "react-router";

export default function NavigationProgressBar() {
  const location = useLocation();

  // Combine pathname and search for comparison
  const currentUrl = `${location.pathname}${location.search}`;
  
  // Store the previous URL in a ref
  const ref = useRef(currentUrl);

  useEffect(() => {
    const url = `${location.pathname}${location.search}`;

    if (ref.current !== url) {
      nprogress.complete();
    }

    ref.current = url;
  }, [location.search, location.pathname]);

  return <NavigationProgress />;
}
